"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _TextFieldAdapter = _interopRequireDefault(require("../../Adapters/TextFieldAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TrustNumberField = function TrustNumberField(props) {
  var isValid = function isValid(value) {
    var re = /^[A-Za-z0-9 /-]{5,18}$/;
    return value && re.test(value) ? undefined : "Please enter a valid Trust Number";
  };

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, _extends({
    name: "trustNumber",
    validate: isValid,
    label: "Trust Number",
    component: _TextFieldAdapter.default,
    subscription: {
      touched: true,
      value: true,
      error: true
    },
    fullWidth: true,
    inputProps: {
      maxLength: 18
    },
    required: true
  }, props));
};

var _default = TrustNumberField;
exports.default = _default;